// extracted by mini-css-extract-plugin
module.exports = {"bannedText":"styles_bannedText__2buJB"};